import api from '../../store/config/api';
import { PHONE as SCHEMA } from '../../schemas'; // eslint-disable-line import/named

export const [
  POST_PHONE,
  POST_PHONE_REQUEST,
  POST_PHONE_SUCCESS,
  POST_PHONE_FAILURE
] = api.buildTypes('POST_PHONE');

export function postPhone({ teamName, username, phone }) {
  return {
    type: POST_PHONE,
    payload: {
      url: `teams/${teamName}/users/${username}/phones/${phone}/verification`,
      schema: SCHEMA,
      options: {
        method: 'POST'
      }
    }
  };
}

export const [
  VERIFY_PHONE,
  VERIFY_PHONE_REQUEST,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_FAILURE
] = api.buildTypes('VERIFY_PHONE');

export function verifyPhone({ teamName, username, phone, code }) {
  return {
    type: VERIFY_PHONE,
    payload: {
      url: `teams/${teamName}/users/${username}/phones/${phone}/verification/${code}`,
      schema: SCHEMA,
      options: {
        method: 'PUT'
      }
    }
  };
}

export const [
  DELETE_PHONE,
  DELETE_PHONE_REQUEST,
  DELETE_PHONE_SUCCESS,
  DELETE_PHONE_FAILURE
] = api.buildTypes('DELETE_PHONE');

export function deletePhone({ teamName, username, phone }) {
  return {
    type: DELETE_PHONE,
    payload: {
      url: `teams/${teamName}/users/${username}/phones/${phone}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/phone.js